import React from 'react';
import { twMerge } from 'tailwind-merge';

type WebUiButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
};

export function WebUiButton({
  children,
  className,
  ...other
}: WebUiButtonProps) {
  return (
    <button
      type="button"
      className={twMerge('webui-button', className)}
      {...other}
    >
      {children}
    </button>
  );
}
